import { computed } from 'vue'
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
import { i18nState } from '@/i18n'
import { localizedAlternateLinks, localizedUrl, normalizeSeoLocale } from '@/utils/seoUrls'

function buildCanonicalPath(route) {
  if (route.name === 'PaperDetail' || route.name === 'AcademyPaperDetail') {
    const paperId = String(route.params?.paperId || '').trim()
    if (paperId) {
      return `/academy/papers/${encodeURIComponent(paperId)}`
    }
  }

  if (route.path === '/academy/papers') {
    const paperFromQuery = Array.isArray(route.query?.paper) ? route.query.paper[0] : route.query?.paper
    const paperId = String(paperFromQuery || '').trim()
    if (paperId) return `/academy/papers/${encodeURIComponent(paperId)}`
  }

  return route.path || '/'
}

export function useCanonical () {
  const route = useRoute()
  const canonicalPath = computed(() => buildCanonicalPath(route))
  const canonicalHref = computed(() => localizedUrl(canonicalPath.value, i18nState.locale))

  useHead(() => ({
    htmlAttrs: {
      lang: normalizeSeoLocale(i18nState.locale)
    },
    link: [
      {
        key: 'canonical',
        rel: 'canonical',
        href: canonicalHref.value
      },
      ...localizedAlternateLinks(canonicalPath.value)
    ]
  }))
}
